module.exports = __webpack_public_path__ + "img/13.a5af4d13.png";